import React from "react";
import Highcharts from "highcharts";
import HighchartReact from "highcharts-react-official";
import { BasicChartProps } from "./types";

export const BasicChart = React.forwardRef(
  ({ height = 500, immutable = false, options, style }: BasicChartProps, ref: any) => {
    style = {
      height,
      ...style
    };

    return (
      <HighchartReact
        ref={ref}
        highchart={Highcharts}
        immutable={immutable}
        options={{
          credits: false,
          exporting: { enabled: false },
          ...options
        }}
        containerProps={{ style }}
      />
    );
  }
);
